import { IAuditoriumBase } from '../../interfaces/auditorium/auditorium-base.interface';
import { Address } from '../address/address.model';

export class AuditoriumBase implements IAuditoriumBase {

  readonly name: string;
  readonly capacity: number;
  readonly useVenueAddress: boolean;
  readonly address: Address;

  constructor(iAuditoriumBase: IAuditoriumBase) {
    this.name = iAuditoriumBase.name;
    this.capacity = iAuditoriumBase.capacity;
    this.useVenueAddress = iAuditoriumBase.useVenueAddress;
    this.address = iAuditoriumBase.address ? new Address(iAuditoriumBase.address) : null;
  }

}
